<div class="legend-container">
  <div class="flex-centered legend-item" *ngFor="let legendItem of settings" [ngStyle]="{'background': legendItem.color}">
    <label class="title">{{ legendItem.title | translate}}</label>
    <label>{{ legendItem.min + ' - ' + legendItem.max}}</label>
  </div>
</div>
